import {
  ColumnDirective,
  ColumnsDirective,
  EditSettingsModel,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Inject,
  DetailRow,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
  Column,
  RowSelectEventArgs,
  Group,
} from '@syncfusion/ej2-react-grids';
import React, { Component } from 'react';
import {GetBackendUrlForGlobalFunctions, GetErpTypeFromConfig} from '../../App';
import ReactDOM from 'react-dom';
import { getValue } from '@syncfusion/ej2-base';
import { getusers } from '../../services/Users/Users';
import './style.css';
import { FiChevronDown } from 'react-icons/fi';
import { BsCheck2All, BsClouds, BsThreeDots } from 'react-icons/bs';
import { BiRefresh } from 'react-icons/bi';
import {
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import SystemLog from './SystemLog';
import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
import Message from '../../utils/Message/Message';
import { FaPlay, FaStop } from 'react-icons/fa';
import { all_information, loadingShow } from '../../App';
import CompanyTable from '../Settings/Security/CampanyPortfolio/CampanyPortfolio';
import {
  EditContainer,
  EditContainerTask,
  getContainer,
  getContainerTaskAll,
  getContainerTaskOne,
} from '../../services/Dig/SyncContainer/SyncContainerServices';
import axios from 'axios';
import {
  Addsource_request,
  Deletesource_request,
  getsource_request,
} from '../../services/Dig/RequestSourceService/RequestSourceService';
import { io } from 'socket.io-client';
interface IProps {}
interface IState {
  CompanyData: any;
  UserAllData: any;
  UsersTempData: any;
  ContainerAllData: any;
  ContainerTempData: any;
  ChildGrid: any;
  ChildData: any;
  hideAddDialogLogMessage: any;
  logMessage: any;
}

export default class TaskTracker extends Component<IProps, IState> {
  private current_filter: string = '';
  private selectedShowLogMessageClickedItem: {
    container_task_id: number | null;
  } = {
    container_task_id: null,
  };
  public editOptions: EditSettingsModel = {
    allowAdding: false,
    allowDeleting: false,
    allowEditing: false,
    allowEditOnDblClick: false,
    showConfirmDialog: false,
    showDeleteConfirmDialog: false,
  };
  public shipFormat: object = { type: 'date', format: 'dd/MM/yyyy' };
  public toolbarOptions1 = ['Search'];
  public toolbarOptions = ['Search'];
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  private gridCompanyTasktracker: any;
  private gridContainerTasktracker: GridComponent;

  private dialogIns: DialogComponent;
  private buttons: ButtonPropsModel[];
  private timer: any = '';
  private textareaObjLog: TextBoxComponent;
  private isMountedTT: boolean = false;
  private intervalId: NodeJS.Timeout | null = null;
  private boundFlag: boolean = true;
  private expandedRows: Array<any> = [];
  private source = axios.CancelToken.source();
  private currentChildGrid: any;
  private current_row_index: number = 1;

  public showLogMessageClickedItem: { container_task_id: number | null } = {
    container_task_id: null,
  };
  private socket = io(GetBackendUrlForGlobalFunctions() as string, {
    autoConnect: false,
    transports: ['websocket'],
  });
  constructor(props: IProps) {
    super(props);
    this.textareaObjLog = new TextBoxComponent({});
    this.textareaObjLog = new TextBoxComponent({});
    this.gridContainerTasktracker = new GridComponent(props);
    this.dialogIns = new DialogComponent({});
    this.dialogIns = new DialogComponent({});
    this.state = {
      CompanyData: [],
      UserAllData: [],
      UsersTempData: [],
      ContainerAllData: [],
      ContainerTempData: [],
      ChildGrid: {},
      ChildData: [],
      hideAddDialogLogMessage: false,
      logMessage: '',
    };
    this.buttons = [
      {
        click: async () => {
          await this.getContainersTasks();
          Message.success('Refreshed');
          this.state.ChildData.map(
            (eachTask: { log_message: string; container_task_id: number }) => {
              if (
                eachTask.container_task_id ===
                this.selectedShowLogMessageClickedItem.container_task_id
              ) {
                this.textareaObjLog.value = eachTask.log_message;
              }
            }
          );
        },
        buttonModel: {
          content: 'Refresh',
          iconCss: 'e-icons e-refresh',

          cssClass: 'buttonrefreshforlogmessage',
        },
      },
      {
        click: () => {
          this.dialogIns.visible = false;
          this.textareaObjLog.value = '';
          this.dialogIns.visible = false;
          this.textareaObjLog.value = '';
        },
        buttonModel: {
          content: 'OK',
        },
      },
    ];
  }
  dateFormatter(dateString: string | null): string {
    if (!dateString) return '';

    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  getContainer() {
    loadingShow(true, 'Loading');
    this.boundFlag = true;
    getContainer({ org_id: all_information.company_id }, this.source)
      .then((el) => {
        loadingShow(false);
        let filteredData: Array<any> = [];
        if (this.current_filter === 'S') {
          filteredData = el.data.filter((item: any) => item.status === true);
        } else if (this.current_filter === 'E') {
          filteredData = el.data.filter((item: any) => item.status === false);
        } else {
          filteredData = el.data;
        }
        // filteredData.map((item) => {
        //   const dateFields = [
        //     'enabled_date',
        //     'next_run',
        //     'start_date',
        //     'last_run',
        //   ];

        //   dateFields.forEach((field) => {
        //     if (typeof item[field] === 'string' && item[field] !== '') {
        //       item[field] = new Date(item[field]);
        //     }
        //   });

        //   return item;
        // });
        const erpType = GetErpTypeFromConfig();
        const typeAItems = filteredData.filter(item => item.erp_type_name === erpType);
        if (this.isMountedTT) {
          // this.gridContainerTasktracker.dataSource = el.data;
          console.log("typeAItems: ",typeAItems)
          this.setState({
            ContainerTempData: typeAItems,
          });
        }
      })
      .catch((err: any) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
    this.getContainersTasks();
  }
  getUsers() {
    getusers().then((res) => {
      const model = res.data.map((result: any) => {
        return {
          ...result,
          id: result.user_id,
          text: result.first_name + ' ' + result.last_name,
          company_id: result.company_id,
          color: result.status_id ? '#339933' : '#C90016',
          usersActiveText: result.status_id ? 'ACTIVE' : 'INACTIVE',
          isChecked: result.isSupport,
          isAdmin: result.isAdmin,
          isApprover: result.isAprover,
        };
      });
      if (this.isMountedTT) {
        this.setState({ UserAllData: model });
      }
    });
  }
  async getContainersTasks() {
    await getContainerTaskAll(
      { org_id: all_information.company_id },
      undefined
    ).then((res) => {
      this.setState({ ChildData: res.data });
    });
  }
  private cellRenderContainerTask = (args: any) => {
    if ((args.column as Column).field === 'status') {
      const val = getValue((args.column as Column).field, args.data);
      let color = '';
      let textColor = '';
      let text = '';
      if (val === true) {
        color = '#339933';
        text = 'SUCCESS';
        textColor = 'white';
      } else if (val === false) {
        color = '#C90016';
        text = 'ERROR';
        textColor = 'white';
      }
      ReactDOM.render(
        <div
          style={{
            backgroundColor: color,
            padding: '5px',
            textAlign: 'center',
            color: textColor,
            borderRadius: '5px',
          }}
        >
          {text}
        </div>,
        args.cell as Element
      );
    }
    if ((args.column as Column).field === 'log_message') {
      const val = getValue((args.column as Column).field, args.data);
      ReactDOM.render(
        <button
          className='btn btn-warning'
          onClick={() => {
            this.setState({ hideAddDialogLogMessage: true });
            this.selectedShowLogMessageClickedItem = args.data;
            this.textareaObjLog.value = val;
            this.getContainersTasks();
          }}
        >
          Show Log Message
        </button>,
        args.cell as Element
      );
    }
    if ((args.column as Column).field === 'isRun') {
      args.cell.innerHTML = '';
      let divContainer = document.createElement('div');
      divContainer.style.display = 'flex';
      divContainer.style.flexDirection = 'row';
      let spanEx = document.createElement('span');
      let buttonEx = document.createElement('button');
      let spanStop = document.createElement('span');
      let buttonStop = document.createElement('button');
      let spanRefresh = document.createElement('span');
      let buttonRefresh = document.createElement('button');

      buttonStop.className = 'execute_button_task';
      buttonStop.style.marginRight = '5px';
      buttonStop.onclick = this.HandlerCancelTask.bind(this, args.data);
      spanStop.classList.add('e-icons');
      spanStop.classList.add('e-bullet-3');
      spanStop.style.fontSize = '10px';
      spanStop.style.color = '#C90016';
      buttonStop.disabled = args.data.isDone;
      buttonStop.appendChild(spanStop);

      spanEx.classList.add('e-icons');
      spanEx.classList.add('e-play');
      spanEx.style.fontSize = '15px';
      spanEx.style.color = '#00B900';

      buttonEx.className = 'execute_button_task';
      buttonEx.style.marginRight = '5px';
      buttonEx.onclick = this.HandlerExecuteTask.bind(this, args.data, false);
      buttonEx.disabled = !args.data.isDone;
      buttonEx.appendChild(spanEx);

      spanRefresh.classList.add('e-icons');
      spanRefresh.classList.add('e-refresh');
      spanRefresh.style.fontSize = '18px';
      spanRefresh.style.color = '#00B900';
      buttonRefresh.className = 'execute_button_task';
      buttonRefresh.style.marginRight = '5px';
      buttonRefresh.onclick = this.HandlerRefreshTask.bind(this, args.data);
      buttonRefresh.appendChild(spanRefresh);
      divContainer.appendChild(buttonEx);
      divContainer.appendChild(buttonStop);
      divContainer.appendChild(buttonRefresh);
      args.cell.appendChild(divContainer);
    }

    if ((args.column as Column).field === 'isFull') {
      const val = getValue((args.column as Column).field, args.data);
      ReactDOM.render(
        <SwitchComponent
          checked={args.data.isFull}
          onChange={this.switchHandler.bind(this, args.data)}
        />,
        args.cell as Element
      );
    }
    if ((args.column as Column).field === 'status') {
      const val = getValue((args.column as Column).field, args.data);
      let current_content;
      if (val === 0) {
        current_content = (
          <div
            style={{
              backgroundColor: '#339933',
              width: '100%',
              height: 25,
              borderRadius: 5,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              color: 'white',
            }}
          >
            SUCCESS
          </div>
        );
      } else if (val === 1) {
        current_content = (
          <div
            style={{
              backgroundColor: '#C90016',
              width: '100%',
              height: 25,
              borderRadius: 5,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              color: 'white',
            }}
          >
            ERROR
          </div>
        );
      } else if (val === 2) {
        current_content = (
          <div
            style={{
              backgroundColor: '#339933',
              width: '100%',
              height: 25,
              borderRadius: 5,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              color: 'white',
            }}
          >
            RUNNING
          </div>
        );
      } else if (val === 3) {
        current_content = (
          <div
            style={{
              backgroundColor: '#fcba03',
              width: '100%',
              height: 25,
              borderRadius: 5,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              color: 'black',
            }}
          >
            PENDING
          </div>
        );
      }
      ReactDOM.render(<div>{current_content}</div>, args.cell as Element);
    }
  };
  async componentDidMount() {
    this.socket.on('updateTask', (args) => {
      if (this.currentChildGrid) {
        args.data.changes.map((item: string) => {
          let theValue = args.data.theData[item];
          // this.currentChildGrid.setCellValue(
          //   this.current_row_index,
          //   item,
          //   theValue
          // );
        });
      }
    });
    this.socket.connect();

    this.socket.on('OnDeletedOrdersFeedback', (data: any) => {
      let theData = JSON.parse(data);
      let theMessage = theData.request_sql;
      if (theMessage.includes('failed')) {
        Message.error(theMessage);
      } else {
        Message.success(theMessage);
      }
    });

    this.isMountedTT = true;
    this.getContainer();
    this.getUsers();
    $('.collapse-tasktracker-icon').click(function () {
      $('.show-taskttracker-content').toggleClass('show-tasktracker');
      $('#rotate-icon-tasktracker').toggleClass('rotateIcon-tasktracker');
    });
  }
  componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<IState>,
    snapshot?: any
  ): void {
    if (
      prevState.hideAddDialogLogMessage !== this.state.hideAddDialogLogMessage
    ) {
      if (this.state.hideAddDialogLogMessage) {
        this.startRequestInterval();
      }
      if (!this.state.hideAddDialogLogMessage) {
        this.clearRequestInterval();
      }
    }
  }

  startRequestInterval() {
    this.clearRequestInterval();
    if (this.state.hideAddDialogLogMessage) {
      this.intervalId = setInterval(async () => {
        await this.getContainersTasks();
        this.state.ChildData.map(
          (eachTask: { log_message: string; container_task_id: number }) => {
            if (
              eachTask.container_task_id ===
              this.selectedShowLogMessageClickedItem.container_task_id
            ) {
              this.textareaObjLog.value = eachTask.log_message;
            }
          }
        );
      }, 5000);
    }
  }

  clearRequestInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
  componentWillUnmount() {
    this.socket.disconnect();
    if (this.timer !== '') {
      clearInterval(this.timer);
    }
    this.isMountedTT = false;
    if (this.source) {
    }
    this.clearRequestInterval();
  }
  cellRenderContainer = (args: any) => {
    if ((args.column as Column).field === 'Status_Id') {
      if ((args.column as Column).field === 'Status_Id') {
        const val = getValue((args.column as Column).field, args.data);
        let color = '';
        let textColor = '';
        let text = '';
        if (val === 0) {
          color = '#339933';
          text = 'ACTIVE';
          textColor = 'white';
        } else if (val === 1) {
          color = '#C90016';
          text = 'INACTIVE';
          textColor = 'white';
        } else if (val === 2) {
          color = '#FFCA2C';
          text = 'WARNING';
          textColor = 'black';
        }
        ReactDOM.render(
          <div
            style={{
              backgroundColor: color,
              padding: '5px',
              textAlign: 'center',
              color: textColor,
              borderRadius: '5px',
            }}
          >
            {text}
          </div>,
          args.cell as Element
        );
      }
      if ((args.column as Column).field === 'enabled') {
        const val = getValue((args.column as Column).field, args.data);
        let color = '';
        let textColor = '';
        let text = '';
        if (val === true) {
          color = '#339933';
          text = 'ENABLE';
          textColor = 'white';
        } else if (val === false) {
          color = '#C90016';
          text = 'DISABLE';
          textColor = 'white';
        }
        ReactDOM.render(
          <div
            style={{
              backgroundColor: color,
              padding: '5px',
              textAlign: 'center',
              color: textColor,
              borderRadius: '5px',
            }}
          >
            {text}
          </div>,
          args.cell as Element
        );
      }
      if ((args.column as Column).field === 'log_message') {
        const val = getValue((args.column as Column).field, args.data);
        ReactDOM.render(
          <button
            className='btn btn-warning'
            onClick={() => {
              this.textareaObjLog.value = val;
              this.textareaObjLog.value = val;
              this.dialogIns.open();
            }}
          >
            Show Log Message
          </button>,
          args.cell as Element
        );
      }
    }
  };
  public rowselect(args: RowSelectEventArgs): void {
    let selRecord: any = args.data;
    let dataUsers: any = [];
    // let dataContainer:any=[];
    const companyId = selRecord.id;
    const adaptorId = selRecord.adaptor_id;
    const containerDatas = this.gridContainerTasktracker.dataSource as any;
    const dataContainer = containerDatas.filter(
      (item: any) => item.adapter_id === adaptorId
    );
    this.state.UserAllData.map((item: any) => {
      if (item.company_id === companyId && item.isSupport === true) {
        dataUsers.push(item);
      }
    });
    (this.gridContainerTasktracker as GridComponent).dataSource = dataContainer;
    this.setState({
      UsersTempData: dataUsers,
      ContainerTempData: dataContainer,
    });
  }
  clickCollapseUser = (id: any) => {
    const t = $(`#user_${id}`);
    t.next().toggleClass('show');
    t.children()
      .next('.collasible-users-second-item')
      .toggleClass('toggle-rotate');
    $('.collasibleUsers').parent().removeClass('active-item');
    t.parent().addClass('active-item');
  };
  genericUserId(id: any): string {
    return 'user_' + id;
  }
  usersTemplate = (el: any) => {
    return (
      <div key={Math.random()} className='containerCollapseUsers'>
        <div
          id={this.genericUserId(el.id)}
          className='collasibleUsers'
          onClick={() => this.clickCollapseUser(el.id)}
        >
          <div className='collapsible-users-first-item'>
            <div
              style={{ backgroundColor: el.color }}
              className='status-span'
            ></div>
            <div style={{ marginTop: '6px' }}>
              <label className='text-color'>{el.text}</label>
            </div>
          </div>
          <div className='collasible-users-second-item'>
            <FiChevronDown size={20} />
          </div>
        </div>
        <div className='collasibleUsersContent'>
          <div className='collasibleUserSubContent'>
            <div className='contact-user'>
              <div>
                <label className='text-sub-color '>Contact Number : </label>
                <label className=' explain-label'>{el.contactNumber}</label>
              </div>
              <div>
                <label className='text-sub-color '>Email : </label>
                <label className=' explain-label'>{el.email}</label>
              </div>
            </div>
            <div className='action-content-user'>
              <div>
                <label className='text-sub-color'>Status : </label>
                <button
                  // onClick={() => this.clickActionUsersStatus(el.id)}
                  disabled={true}
                  style={{ backgroundColor: el.color }}
                  className='status-action'
                >
                  {el.usersActiveText}
                </button>
              </div>
              <div className='action-content-sub-user'>
                <div>
                  <label className='text-sub-color'>Roles : </label>
                </div>
                <div>
                  <button
                    id='adminUser'
                    className='status-action'
                    disabled={true}
                    //  onClick={() => this.clickActionUserAdmin(el.id)}
                  >
                    {el.isAdmin ? (
                      <div>
                        <label
                          style={{ color: '#000' }}
                          className='text-sub-color'
                        >
                          ADMIN
                        </label>
                        <BsCheck2All size={18} color='white' />
                      </div>
                    ) : (
                      <label
                        style={{ color: '#000' }}
                        className='text-sub-color'
                      >
                        ADMIN
                      </label>
                    )}
                  </button>
                  <button
                    id='approverUser'
                    className='status-action'
                    disabled={true}
                    // onClick={() => this.clickActionUserApprover(el.id)}
                  >
                    {el.isApprover ? (
                      <div>
                        <label
                          style={{ color: 'white' }}
                          className='text-sub-color'
                        >
                          APPROVER
                        </label>
                        <BsCheck2All size={18} color='white' />
                      </div>
                    ) : (
                      <label
                        style={{ color: 'white' }}
                        className='text-sub-color'
                      >
                        APPROVER
                      </label>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  private onSuccessStatus() {
    let data = this.state.ContainerAllData;
    this.current_filter = 'S';
    if (this.gridCompanyTasktracker.getSelectedRecords().length !== 0) {
      const Adaptor_Id =
        this.gridCompanyTasktracker.getSelectedRecords()[0].Adaptor_Id;
      data = this.state.ContainerAllData.filter(
        (item: any) => item.adapter_id === Adaptor_Id
      );
    } else {
      data = this.state.ContainerAllData;
    }
    let successData = data.filter((item: any) => item.status === 0);
    (this.gridContainerTasktracker as GridComponent).dataSource = successData;
    this.setState({ ContainerTempData: successData });
  }
  private onPendingStatus() {
    let data = this.state.ContainerAllData;
    this.current_filter = 'S';
    if (this.gridCompanyTasktracker.getSelectedRecords().length !== 0) {
      const Adaptor_Id =
        this.gridCompanyTasktracker.getSelectedRecords()[0].Adaptor_Id;
      data = this.state.ContainerAllData.filter(
        (item: any) => item.adapter_id === Adaptor_Id
      );
    } else {
      data = this.state.ContainerAllData;
    }
    let successData = data.filter((item: any) => item.status === 3);
    (this.gridContainerTasktracker as GridComponent).dataSource = successData;
    this.setState({ ContainerTempData: successData });
  }
  private onErrortatus() {
    let data = this.state.ContainerAllData;
    this.current_filter = 'E';
    if (this.gridCompanyTasktracker.getSelectedRecords().length !== 0) {
      const Adaptor_Id =
        this.gridCompanyTasktracker.getSelectedRecords()[0].Adaptor_Id;
      data = this.state.ContainerAllData.filter(
        (item: any) => item.adapter_id === Adaptor_Id
      );
    } else {
      data = this.state.ContainerAllData;
    }
    let errorData = data.filter((item: any) => item.status === 1);
    (this.gridContainerTasktracker as GridComponent).dataSource = errorData;
    this.setState({ ContainerTempData: errorData });
  }
  private onCreateConditionTextArea(): void {
    // if (this.showLogMessageClickedItem.container_task_id) {
    //   getContainerTaskOne(
    //     this.showLogMessageClickedItem.container_task_id
    //   ).then((res) => {
    //     let data = res.data;
    //     if (this.textareaObjLog) {
    //       if (this.textareaObjLog.value !== data.log_message) {
    //         this.textareaObjLog.value = data.log_message;
    //       }
    //     }
    //   });
    // }

    var theTextBox = this.textareaObjLog as any;
    var theTextBox = this.textareaObjLog as any;
    if (theTextBox) {
      theTextBox?.addAttributes({ rows: 5 });
      theTextBox.respectiveElement.style.height = '250px';
      theTextBox.respectiveElement.style.overflow = 'auto';
      theTextBox.respectiveElement.style.maxHeight = '250px';
    }
    //  this.textareaObjLog.respectiveElement.style.color="red"
  }

  private toolbarTemplateContainer() {
    return (
      <div className='toolbarTemplate'>
        <div className='toolbar-action'>
          <button
            onClick={this.onSuccessStatus.bind(this)}
            className='btn btn-success'
          >
            SUCCESS
          </button>
          <button
            className='btn '
            style={{
              background: 'gray',
            }}
            onClick={this.onPendingStatus.bind(this)}
          >
            PENDING
          </button>
          <button
            onClick={this.onErrortatus.bind(this)}
            className='btn btn-danger'
          >
            ERROR
          </button>
          <button
            onClick={this.onErrortatus.bind(this)}
            className='btn btn-warning'
          >
            RUNNING
          </button>
          {/* <BsClouds
            onClick={this.loadAllData.bind(this)}
            color='blue'
            size={25}
          /> */}
          <button
            style={{ backgroundColor: 'transparent', border: 'none' }}
            onClick={this.getContainer.bind(this)}
          >
            <BiRefresh size={25} />
            <span>Refresh</span>
          </button>
        </div>
      </div>
    );
  }
  switchHandler(el: any, args: any) {
    var theObj = {
      ...el,
      isFull: args.target.properties.checked,
      //last_row_id: 0,
    };
    EditContainerTask(theObj)
      .then((elIn) => {
        Message.success('Success');
        this.HandlerRefreshTask(el, args.syntheticEvent);
      })
      .catch((er) => {
        args.target.checked = false;
        if (er.response) {
          Message.error(
            er.response.data +
              '\n' +
              er.response.status +
              '\n' +
              er.response.headers
          );
        } else if (er.request) {
          Message.error(er.request);
        } else {
          Message.error('Error: ' + er.message);
        }
        Message.error(er.config);
      });
  }

  ExecuteTemp(el: any) {
    let isInitial = false;
    let uniqid = 'button' + el.index;
    const FancyButton = React.forwardRef((props: any, ref) => (
      <button className='FancyButton'>{props.children}</button>
    ));
    return (
      // <div
      //   style={{
      //     display: 'flex',
      //     flexDirection: 'row',
      //   }}
      // >
      //   <button
      //     id={uniqid}
      //     className='execute_button '
      //     onClick={this.HandlerExecuteContainer.bind(this, el, uniqid)}
      //     disabled={!el.isDone}
      //     style={{
      //       marginRight: 5,
      //     }}
      //   >
      //     <FaPlay size={10} color={'#00B900'} />
      //   </button>

      //   <button
      //     id={uniqid}
      //     className='execute_button'
      //     disabled={el.isDone}
      //     style={{
      //       marginRight: 5,
      //     }}
      //     onClick={this.HandlerCancelContainer.bind(this, el, uniqid)}
      //   >
      //     <FaStop size={10} color='#C90016' />
      //   </button>
      //   <button
      //     className='execute_button_task'
      //     style={{
      //       marginRight: 5,
      //     }}
      //     onClick={this.HandlerRefreshContainer.bind(this, el)}
      //   >
      //     <BiRefresh size={20} color={'#00B900'} />
      //   </button>
      // </div>
      <></>
    );
  }
  HandlerRefreshTask(el: any, args: any) {
    this.showLogMessageClickedItem = el;
    var childGridIns = args.target.closest('.e-grid').ej2_instances[0];
    var rowInfo = childGridIns.getRowInfo(args.target.closest('td'));
    var rowIndex = rowInfo.rowIndex;
    if (!args.target.disabled) {
      args.target.disabled = true;
      getContainerTaskOne(el.container_task_id).then((res) => {
        let data = res.data;
        childGridIns.updateRow(rowIndex, data);
        if (this.textareaObjLog) {
          if (this.textareaObjLog.value !== data.log_message) {
            this.textareaObjLog.value = data.log_message;
          }
        }
        args.target.disabled = true;
      });
    }
  }

  HandlerExecuteTask(el: any, isSwitch: boolean, args: any) {
    var theObj = {
      isRun: true,
      isDone: false,
      isCancelRequest: false,
      isFull: el.isFull,
      container_task_id: el.container_task_id,
    };
    var theInterval: any = '';
    var childGridIns: any;
    if (isSwitch) {
      childGridIns = args.currentTarget?.closest('.e-grid').ej2_instances[0];
    } else {
      childGridIns = args.target?.closest('.e-grid').ej2_instances[0];
    }
    this.currentChildGrid = childGridIns;
    var rowInfo = childGridIns?.getRowInfo(args.target.closest('td'));
    var rowIndex = rowInfo.rowIndex;
    this.current_row_index = rowIndex;
    var the_all = all_information;
    if (!args.target.disabled) {
      args.target.disabled = true;
      EditContainerTask(theObj)
        .then(async (elIn) => {
          this.getContainersTasks();
          Message.success('Task initiated');
          // theInterval = setInterval(() => {
          //   getContainerTaskAll(
          //     { org_id: all_information.company_id },
          //     undefined
          //   ).then((res) => {
          //     let finded: Array<any> = [];
          //     finded.push({
          //       ...res.data.filter((elCon: any) => {
          //         return elCon.container_task_id === el.container_task_id;
          //       })[0],
          //     });
          //     childGridIns.updateRow(rowIndex, finded[0]);
          //     if (this.textareaObjLog) {
          //       if (this.textareaObjLog.value !== finded[0].log_message) {
          //         this.textareaObjLog.value = finded[0].log_message;
          //       }
          //     }
          //     if (finded[0].isDone) {
          //       finded[0].isRun = false;
          //       finded[0].isDone = true;
          //       EditContainerTask(finded[0]).then((el) => {});
          //       Message.info('Done! Please check out the task logs');
          //       args.target.disabled = false;
          //       clearInterval(theInterval);
          //     }
          //   });
          // }, 1000);
          var theRequestId = await this.createARequest('', '');
          if (theRequestId !== -1) {
            this.watchTask(
              theRequestId,
              theInterval,
              theObj,
              childGridIns,
              rowInfo,
              args.target.disabled
            );
          }
        })
        .catch((er) => {
          if (er.response) {
            Message.error(
              er.response.data +
                '\n' +
                er.response.status +
                '\n' +
                er.response.headers
            );
          } else if (er.request) {
            Message.error(er.request);
          } else {
            Message.error('Error: ' + er.message);
          }
          Message.error(er.config);
        });
    }
  }
  HandlerCancelTask(el: any, args: any) {
    var theObj = {
      ...el,
      isRun: false,
      status: 3,
      isDone: true,
      isCancelRequest: true,
    };
    var container_task_id = el.container_task_id;
    var childGridIns = args.target.closest('.e-grid').ej2_instances[0];
    var rowInfo = childGridIns.getRowInfo(args.target.closest('td'));
    var rowIndex = rowInfo.rowIndex;
    EditContainerTask(theObj)
      .then((el) => {
        Message.success('Task canceled');
        getContainerTaskAll(
          { org_id: all_information.company_id },
          undefined
        ).then((res) => {
          let finded: Array<any> = [];
          finded.push({
            ...res.data.filter((elCon: any) => {
              return elCon.container_task_id === container_task_id;
            })[0],
          });
          childGridIns.updateRow(rowIndex, finded[0]);
        });
      })
      .catch((er) => {
        Message.error('Task cancel failed');
        if (er.response) {
          Message.error(
            er.response.data +
              '\n' +
              er.response.status +
              '\n' +
              er.response.headers
          );
        } else if (er.request) {
          Message.error(er.request);
        } else {
          Message.error('Error: ' + er.message);
        }
        Message.error(er.config);
      });
  }
  HandlerRefreshContainer(el: any, args: any) {
    if (!args.currentTarget.disabled) {
      args.currentTarget.disabled = true;
      getContainer(this.source).then((res) => {
        let finded: Array<any> = [];
        finded.push({
          ...res.data.filter((elCon: any) => {
            return elCon.container_id === el.container_id;
          })[0],
        });
        args.target.disabled = false;
        this.gridContainerTasktracker.setRowData(el.container_id, finded[0]);
      });
    }
  }
  HandlerExecuteContainer(el: any, uniqid: string, ref: any) {
    var theInterval: any = '';
    $(`#${uniqid}`).prop('disabled', true);
    var theObj = {
      ...el,
      isRun: true,
      log_message: el.log_message === null ? '' : el.log_message,
      isDone: false,
      isCancelRequest: false,
    };
    EditContainer(theObj)
      .then((elIn) => {
        Message.success('Container initiated');
        var theGrid = this.gridContainerTasktracker;
        theInterval = setInterval(() => {
          getContainer({ org_id: all_information.company_id }).then((res) => {
            let finded: Array<any> = [];
            finded.push({
              ...res.data.filter((elCon: any) => {
                return elCon.container_id === el.container_id;
              })[0],
            });

            theGrid.setRowData(el.container_id, finded[0]);
            if (finded[0].isDone) {
              finded[0].isRun = false;
              EditContainer(finded[0]).then((el) => {
                //(el);
              });
              Message.info('Done! Please check out the container logs');
              clearInterval(theInterval);
            }
          });
        }, 1000);
        Addsource_request({
          request_sql: '',
          request_result: '',
        })
          .then((el) => {
            var data = el.data;
            this.watchContainer(data.request_id, theInterval, theObj);
          })
          .catch((er) => {
            //(er);
          });
      })
      .catch((er) => {
        if (er.response) {
          Message.error(
            er.response.data +
              '\n' +
              er.response.status +
              '\n' +
              er.response.headers
          );
        } else if (er.request) {
          Message.error(er.request);
        } else {
          Message.error('Error: ' + er.message);
        }
        Message.error(er.config);
      });
  }
  HandlerCancelContainer(el: any, uniqid: string) {
    var theObj = {
      ...el,
      isRun: false,
      log_message: el.log_message === null ? '' : el.log_message,
      isDone: true,
      status: 3,
      isCancelRequest: true,
    };
    EditContainer(theObj)
      .then((el) => {
        getContainer(this.source).then((res) => {
          var theGrid = this.gridContainerTasktracker;
          theObj.isRun = false;
          let finded = res.data.filter((elCon: any) => {
            return elCon.container_id === theObj.container_id;
          });
          theGrid.setRowData(theObj.container_id, finded[0]);
          EditContainer(theObj).then((el) => {
            //(el);
          });
          Message.success('The container is canceled');
        });
      })
      .catch((er) => {
        //(er);
        if (er.response) {
          Message.error(
            er.response.data +
              '\n' +
              er.response.status +
              '\n' +
              er.response.headers
          );
        } else if (er.request) {
          Message.error(er.request);
        } else {
          Message.error('Error: ' + er.message);
        }
        Message.error(er.config);
      });
  }
  watchContainer(request_id: any, intervalUp: any, obj: any) {
    var theTimeOut = setTimeout(() => {
      let finded: Array<any> = [];
      finded.push({
        ...this.state.ContainerTempData.filter((el: any) => {
          return obj.container_id === el.container_id;
        })[0],
      });
      Message.error('Windows service out of order');
      clearInterval(interval);
      clearInterval(intervalUp);
      finded[0].isRun = false;
      finded[0].isDone = true;
      finded[0].status = 3;
      finded[0].isCancelRequest = false;
      var theGrid = this.gridContainerTasktracker;
      EditContainer(finded[0]).then((el) => {
        getContainer(this.source).then((res) => {
          let finded2 = res.data.filter((elCon: any) => {
            return elCon.container_id === finded[0].container_id;
          });
          theGrid.setRowData(finded[0].container_id, finded2[0]);
        });
      });

      Deletesource_request({
        request_id: request_id,
      });
    }, 6000);
    var interval = setInterval(() => {
      getsource_request(request_id)
        .then((el) => {
          var getData = el.data[0];

          if (getData.request_result !== '') {
            clearInterval(interval);
            clearTimeout(theTimeOut);
            Message.success('Windows service is up');
            Deletesource_request({
              request_id: request_id,
            });
          }
        })
        .catch((e) => {
          //(e);
        });
    }, 500);
  }
  watchTask(
    request_id: any,
    intervalUp: any,
    obj: any,
    childGridIns: any,
    rowInfo: any,
    buttonDisabled: boolean
  ) {
    var theTimeOut = setTimeout(() => {
      var rowIndex = rowInfo.rowIndex;
      //Message.error('Windows service out of order');
      console.log('worked');
      clearInterval(interval);
      clearInterval(intervalUp);
      obj.isRun = false;
      obj.isDone = true;
      obj.status = 3;
      obj.isCancelRequest = false;
      obj.isRun = false;
      clearInterval(intervalUp);
      buttonDisabled = false;
      // EditContainerTask(obj).then((el) => {
      //   getContainerTaskOne(obj.container_task_id).then((res) => {
      //     // childGridIns.updateRow(rowIndex, res.data);
      //   });
      // });
      this.deleteRequest(request_id);
    }, 10000);
    var interval = setInterval(() => {
      getsource_request(request_id)
        .then((el) => {
          var getData = el.data[0];
          if (getData.request_result !== '') {
            clearInterval(interval);
            clearTimeout(theTimeOut);
            Message.success('Windows service is up');
            Deletesource_request({
              request_id: request_id,
            });
          }
        })
        .catch((e) => {
          //(e);
        });
    }, 500);
  }
  statusTemplate(e: any) {
    let current_content;
    if (e.status === 0) {
      current_content = (
        <div
          style={{
            backgroundColor: '#339933',
            width: '100%',
            height: 25,
            borderRadius: 5,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            color: 'white',
          }}
        >
          SUCCESS
        </div>
      );
    } else if (e.status === 1) {
      current_content = (
        <div
          style={{
            backgroundColor: '#C90016',
            width: '100%',
            height: 25,
            borderRadius: 5,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            color: 'white',
          }}
        >
          ERROR
        </div>
      );
    } else if (e.status === 2) {
      current_content = (
        <div
          style={{
            backgroundColor: '#339933',
            width: '100%',
            height: 25,
            borderRadius: 5,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            color: 'black',
          }}
        >
          RUNNING
        </div>
      );
    } else if (e.status === 3) {
      current_content = (
        <div
          style={{
            backgroundColor: '#fcba03',
            width: '100%',
            height: 25,
            borderRadius: 5,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            color: 'black',
          }}
        >
          PENDING
        </div>
      );
    }
    // return <div>{current_content}</div>;
    return <></>;
  }
  actionBeginForChild(args: any) {
    if (args.requestType === 'beginEdit') {
      args.cancel = true;
    }
  }
  getContainerData() {
    getContainer({ org_id: all_information.company_id }, this.source).then(
      (el) => {
        let filteredData: Array<any> = [];
        if (this.current_filter === 'S') {
          filteredData = el.data.filter((item: any) => item.status === true);
        } else if (this.current_filter === 'E') {
          filteredData = el.data.filter((item: any) => item.status === false);
        } else {
          filteredData = el.data;
        }
        this.gridContainerTasktracker.dataSource = filteredData;
      }
    );
  }
  detailDataBound = (e: any) => {
    // e.childGrid.dataSource = e.data.children;
    const index = this.gridContainerTasktracker.getRowIndexByPrimaryKey(
      e.data.container_id
    );
    let existing = this.expandedRows.findIndex((el) => el === index);
    if (existing === -1) {
      this.expandedRows.push(index);
    }
  };
  dataBound() {
    if (this.boundFlag) {
      this.boundFlag = false;
      this.expandedRows.map((el) => {
        this.gridContainerTasktracker.detailRowModule.expand(el);
      });
    }
  }
  private onLoad = async (args: any) => {
    await this.getContainersTasks();
    // this.gridContainerTasktracker.childGrid.dataSource = this.state?.ChildData;
    // this.gridContainerTasktracker.refresh();
    // console.log('ChildGrid', this.state.ChildData);
  };
  async createARequest(request: string, message: string): Promise<number> {
    let theRIdentity: number = -1;
    await Addsource_request({
      request_sql: request,
      request_result: message,
      organization_id: all_information.company_id?.toString(),
      app: all_information.app,
    })
      .then((el) => {
        var data = el.data;
        theRIdentity = data.request_id;
      })
      .catch((er) => {
        theRIdentity = -1;
      });
    return theRIdentity;
  }
  deleteRequest(request_id: number) {
    Deletesource_request({
      request_id: request_id,
    });
  }
  // private runTemplate = (args: any) => {
  //   return (
  //     <div>
  //       <button
  //         className='execute_button_task'
  //         onClick={this.HandlerExecuteTask.bind(this, args, false)}
  //         disabled={!args.isDone}
  //         style={{
  //           marginRight: 5,
  //         }}
  //       >
  //         <FaPlay size={10} color={'#00B900'} />
  //       </button>
  //       <button
  //         className='execute_button_task'
  //         disabled={args.isDone}
  //         style={{
  //           marginRight: 5,
  //         }}
  //         onClick={this.HandlerCancelTask.bind(this, args)}
  //       >
  //         <FaStop size={10} color='#C90016' />
  //       </button>
  //       <button
  //         className='execute_button_task'
  //         style={{
  //           marginRight: 5,
  //         }}
  //         onClick={this.HandlerRefreshTask.bind(this, args)}
  //       >
  //         <BiRefresh size={20} color={'#00B900'} />
  //       </button>
  //     </div>
  //   );
  // };
  render() {
    return (
      <div id='task_tracker_dig_element'>
        <div className='tasktracker-sub-content'>
          <div className='container-tasktracker'>
            <CompanyTable
              onRowSelect={this.rowselect.bind(this)}
              isOnlyCompany
            />
          </div>

          <div>
            <div
              id='collapse-tasktracker'
              className='collapse-tasktracker-icon'
            >
              <div>
                <FiChevronDown id='rotate-icon-tasktracker' size={17} />
              </div>
            </div>
            <div className='container-tasktracker show-taskttracker-content'>
              <div className='flexible-div'>
                <div className='tasktracker-sub'>
                  <div className='header-tasktracker-section'>
                    <div className='header-tasktracker-layout'>
                      <div className='second-tasktracker-text'>
                        <span>Agent Service Status</span>
                      </div>
                      <div>
                        <div className='action-icon-tasktracker'>
                          <div
                            className='add-tasktracker-icon'
                            style={{ display: 'none' }}
                          >
                            {/* <IoRemoveSharp size={23} /> */}
                          </div>
                          {/* <div
                            className='add-tasktracker-icon'
                            // onClick={this.dialogOpenComponentList.bind(this)}
                          >
                            <MdOutlinePlaylistAdd size={23} />
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className='responsive-layout-tasktracker'
                    style={{ overflow: 'auto' }}
                  >
                    {/* <SystemLog /> */}
                  </div>
                </div>
                <div className='tasktracker-sub'>
                  <div className='header-tasktracker-section'>
                    <div className='header-tasktracker-layout'>
                      <div className='second-tasktracker-text'>
                        <span>Administrative & Support Contacts</span>
                      </div>
                      <div>
                        <div className='action-icon-tasktracker'>
                          <div
                            className='add-tasktracker-icon'
                            style={{ display: 'none' }}
                          >
                            {/* <IoRemoveSharp size={23} /> */}
                          </div>
                          {/* <div
                            className='add-tasktracker-icon'
                            // onClick={this.dialogOpenComponentList.bind(this)}
                          >
                            <MdOutlinePlaylistAdd size={23} />
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='responsive-layout-tasktracker'>
                    {this.state.UsersTempData.length > 0 ? (
                      <div className='border-div'>
                        {this.state.UsersTempData.map((el: any) =>
                          el.isSupport === true ? this.usersTemplate(el) : null
                        )}
                      </div>
                    ) : (
                      'No records to display'
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='container-tasktracker'>
            <span style={{ height: '100px' }}>Synchronization Container</span>
            <GridComponent
              id='dig-task-tracker-sub-one'
              dataSource={this.state.ContainerTempData}
              editSettings={this.editOptions}
              ref={(g: GridComponent) => (this.gridContainerTasktracker = g)}
              height='60vh'
              allowPaging={true}
              pageSettings={this.pageOptions}
              showColumnMenu={true}
              allowResizing={true}
              allowGrouping={true}
              detailDataBound={this.detailDataBound.bind(this)}
              width='auto'
              enableVirtualMaskRow={false}
              enableHover={false}
              gridLines='Both'
              childGrid={{
                queryString: 'container_id',
                dataSource: this.state.ChildData,
                allowPaging: false,
                queryCellInfo: this.cellRenderContainerTask,
                actionBegin: this.actionBeginForChild,
                created: () => {
                  var childGridsele =
                    this.gridContainerTasktracker.element.querySelectorAll(
                      '.e-grid'
                    ) as any;

                  for (var i = 0; i < childGridsele.length; i++) {
                    this.currentChildGrid = childGridsele[i].ej2_instances[0]; // get the childGrid instances by looping all the childGrid element
                  }
                },
                allowResizing: true,
                editSettings: {
                  allowEditing: true,
                  allowAdding: true,
                  allowDeleting: true,
                },
                enableAltRow: true,
                width: '100%',
                columns: [
                  {
                    field: 'isRun',
                    headerText: 'Execute',
                    textAlign: 'Left',
                    width: '10%',
                    // template: this.runTemplate.bind(this),
                  },
                  {
                    field: 'task_id',
                    headerText: 'Task ID',
                    textAlign: 'Left',
                    width: '10%',
                  },
                  {
                    field: 'container_task_id',
                    headerText: 'Container Task ID',
                    textAlign: 'Left',
                    width: '10%',
                    isPrimaryKey: true,
                  },
                  { field: 'task_name', headerText: 'Task Name', width: '20%' },
                  {
                    field: 'last_sync_start_date',
                    headerText: 'Last Sync Start Date',
                    width: '20%',
                  },
                  {
                    field: 'last_sync_end_date',
                    headerText: 'Last Sync End Date',
                    width: '20%',
                  },
                  {
                    field: 'last_sync_duration',
                    headerText: 'Last Sync Duration',
                    width: '10%',
                  },
                  {
                    field: 'last_sync_count',
                    headerText: 'Last Sync Count',
                    width: '10%',
                  },
                  {
                    field: 'log_message',
                    headerText: 'Log Message',
                    width: '20%',
                  },
                  { field: 'status', headerText: 'Status', width: '10%' },
                  {
                    field: 'isFull',
                    headerText: 'Incremental/Full',
                    width: '10%',
                  },
                ],
              }}
              allowSelection={false}
              queryCellInfo={this.cellRenderContainer}
              rowSelected={this.rowselect.bind(this)}
              toolbarTemplate={this.toolbarTemplateContainer.bind(this)}
              load={this.onLoad.bind(this)}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field='isRun'
                  headerText='Execute'
                  textAlign='Left'
                  template={this.ExecuteTemp.bind(this)}
                  width='15%'
                />
                <ColumnDirective
                  field='container_id'
                  headerText='Container ID'
                  textAlign='Left'
                  width='10%'
                  isPrimaryKey
                />
                <ColumnDirective
                  field='container_name'
                  headerText='Container Name'
                  textAlign='Left'
                  width='15%'
                />
                <ColumnDirective
                  field='adapter_name'
                  headerText='Adapter'
                  width='15%'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='enabled_date'
                  headerText='Enabled Date'
                  width='15%'
                  textAlign='Left'
                  template={(rowData: any) =>
                    rowData.enabled_date
                      ? this.dateFormatter(rowData.enabled_date)
                      : ''
                  }
                />
                <ColumnDirective
                  field='alert_mail'
                  headerText='Alert Mail'
                  width='15%'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='last_run'
                  headerText='Last Run'
                  width='15%'
                  textAlign='Left'
                  template={(rowData: any) =>
                    rowData.last_run ? this.dateFormatter(rowData.last_run) : ''
                  }
                />
                <ColumnDirective
                  field='next_run'
                  headerText='Next Run'
                  width='15%'
                  textAlign='Left'
                  template={(rowData: any) =>
                    rowData.next_run ? this.dateFormatter(rowData.next_run) : ''
                  }
                />
                <ColumnDirective
                  field='interval'
                  headerText='Interval'
                  width='15%'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='log_message'
                  headerText='Log Message'
                  width='15%'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='start_date'
                  headerText='Start Date'
                  width='15%'
                  textAlign='Left'
                  template={(rowData: any) =>
                    rowData.start_date
                      ? this.dateFormatter(rowData.start_date)
                      : ''
                  }
                />
                <ColumnDirective
                  field='status'
                  headerText='Status'
                  template={this.statusTemplate.bind(this)}
                  width='15%'
                  textAlign='Left'
                />
                <ColumnDirective
                  field='enabled'
                  headerText='Enabled'
                  //  template={this.enabledTemplate}
                  width='15%'
                  textAlign='Left'
                />
              </ColumnsDirective>
              <Inject
                services={[DetailRow, Toolbar, Filter, Page, Resize, Group]}
              />
            </GridComponent>

            <DialogComponent
              ref={(ref: DialogComponent) => (this.dialogIns = ref)}
              isModal={true}
              id='defaultDialogAddMapping'
              showCloseIcon={true}
              visible={this.state.hideAddDialogLogMessage}
              header='Log Message'
              width={500}
              height={'400px'}
              buttons={this.buttons}
              enableResize
              open={() => {
                this.setState({ hideAddDialogLogMessage: true });
              }}
              close={() => {
                this.setState({ hideAddDialogLogMessage: false });
                this.textareaObjLog.value = '';
              }}
              content={() => {
                return (
                  <TextBoxComponent
                    ref={(scope: TextBoxComponent) => {
                      this.textareaObjLog = scope;
                    }}
                    created={this.onCreateConditionTextArea.bind(this)}
                    value={this.state.logMessage}
                    multiline={true}
                    placeholder='Condition'
                    style={{ height: '250px' }}
                    readOnly={true}
                  />
                );
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}
